import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemMaterialSummarySelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId)

    switch (bomItem?.type) {
      case 'MaterialHeader':
      case 'Row':
        return bomItem.materialSummary
    }

    return undefined
  }
